<template>
  <span>
    <div v-if="discount > 0" class="mb-3 total-price">
      Aktueller Preis:
      <span class="discounted">-{{ discount }}%</span>
      <span class="price-discounted">{{ price.discounted | currency }}</span>
      <span class="price-total">{{ price.total | currency }}</span>
    </div>
    <div v-else-if="oldPrice > 0" class="mb-3 total-price">
      Aktueller Preis:
      <span class="price-discounted">{{ price.discounted | currency }}</span>
      <span class="price-total">{{ oldPrice | currency }}</span>
    </div>
    <div v-else class="mb-3 total-price">
      Aktueller Preis:
      <span class="price-discounted">{{ totalPrice | currency }}</span>
    </div>
  </span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      price: 'configurator/price',
      stepDiscount: 'configurator/discount'
    }),
    discount () {
      return Number.parseInt(this.stepDiscount)
    },
    totalPrice () {
      return Math.ceil(this.price.total)
    },
    oldPrice () {
      if (typeof this.price.old_price !== 'undefined') {
        if (this.price.old_price === Math.ceil(this.price.total)) {
          return 0
        } else {
          return this.price.old_price
        }
      } else {
        return 0
      }
    }
  }
}
</script>
